/**
 * Image hotspot component
 * 
 * @module image-hotspot
 * @version 1.0.0 
 * @extends HTMLElement
 */

 customElements.component = 'image-hotspot';

 if (!customElements.get(customElements.component)) {
 
    class ImageHotspot extends HTMLElement {

     /**
     * Image hotspot web component
     * 
     * @constructor
     */
    constructor() {

        super();

        this.hotspot = this.dataset.json;
        this.hotspotJSON = this.hotspot.replace(/'/g,"\"");
        this.hotspotJSON = JSON.parse(this.hotspotJSON);

        this.render();

        this.innerHTML = `<div style="position: relative;">` + this.innerHTML + `</div>`;

        this.initEvents();

    }

    /**
     * Render image hotspot
     * 
     * @returns {undefined}
     */
     render() {
        this.innerHTML += `<div style="padding-top:{{ 1 | divided_by: ${this.hotspotJSON.image_hotspot.image_ratio} | times: 100 }}%; line-height: 0;"><img style="width: 100%;height: auto;" alt="${this.hotspotJSON.image_hotspot.image_alt}" loading="lazy" src="${this.hotspotJSON.image_hotspot.image_url}" /></div>`;
        
        this.hotspotJSON.image_hotspot.hotspots.forEach((hotspot, index) => {

            this.renderHotspot(hotspot, index);

        });

        this.innerHTML = `<div style="position: relative;">` + this.innerHTML + `</div>`;

        let contentHtml = "";

        this.hotspotJSON.image_hotspot.hotspots.forEach((hotspot, index) => {

            if(hotspot.content != null && hotspot.link == null ) {
                contentHtml += this.renderHotspotContent(hotspot, index);
            }

        });

        contentHtml = `<div class="image-hotspot__content-wrap">` + contentHtml + `</div>`;

        this.innerHTML += contentHtml;

    }

    /**
     * Render hotspots
     * 
     * @param {object} hotspot A hotspot object.
     * @param {integer} index A hotspot index.
     * @returns {undefined}
     */
     renderHotspot(hotspot, index) {
        if(hotspot.link != null) {

            this.innerHTML += `<span class="image-hotspot__icon" style="top: ${hotspot.positionY}%; left: ${hotspot.positionX}%; position: absolute;">
                <button aria-label="hotspot tag"><a href="${hotspot.link}">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.2733 17.7199L18.2733 11.7199C18.0233 11.472 17.6853 11.333 17.3333 11.3333H12.6666C12.313 11.3333 11.9738 11.4737 11.7238 11.7238C11.4737 11.9738 11.3333 12.313 11.3333 12.6666V17.3333C11.3331 17.5092 11.3678 17.6834 11.4353 17.8459C11.5028 18.0084 11.6018 18.1559 11.7266 18.2799L17.7266 24.2799C17.9766 24.5279 18.3145 24.6669 18.6666 24.6666C19.0196 24.6651 19.3577 24.5236 19.6066 24.2733L24.2733 19.6066C24.5236 19.3577 24.6651 19.0196 24.6666 18.6666C24.6667 18.4906 24.632 18.3164 24.5645 18.1539C24.497 17.9915 24.398 17.844 24.2733 17.7199ZM18.6666 23.3333L12.6666 17.3333V12.6666H17.3333L23.3333 18.6666L18.6666 23.3333ZM14.3333 13.3333C14.531 13.3333 14.7244 13.3919 14.8888 13.5018C15.0533 13.6117 15.1814 13.7678 15.2571 13.9506C15.3328 14.1333 15.3526 14.3344 15.314 14.5283C15.2755 14.7223 15.1802 14.9005 15.0404 15.0404C14.9005 15.1802 14.7223 15.2755 14.5283 15.314C14.3344 15.3526 14.1333 15.3328 13.9506 15.2571C13.7678 15.1814 13.6117 15.0533 13.5018 14.8888C13.3919 14.7244 13.3333 14.531 13.3333 14.3333C13.3333 14.068 13.4386 13.8137 13.6261 13.6261C13.8137 13.4386 14.068 13.3333 14.3333 13.3333Z"/>
                    </svg>
                </a></button>
            </span>`;

        } else if (hotspot.content != null) {

            this.innerHTML += `<span class="image-hotspot__icon" style="top: ${hotspot.positionY}%; left: ${hotspot.positionX}%; position: absolute;">
                <button data-hotspot="${index}" aria-label="hotspot tag">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.2733 17.7199L18.2733 11.7199C18.0233 11.472 17.6853 11.333 17.3333 11.3333H12.6666C12.313 11.3333 11.9738 11.4737 11.7238 11.7238C11.4737 11.9738 11.3333 12.313 11.3333 12.6666V17.3333C11.3331 17.5092 11.3678 17.6834 11.4353 17.8459C11.5028 18.0084 11.6018 18.1559 11.7266 18.2799L17.7266 24.2799C17.9766 24.5279 18.3145 24.6669 18.6666 24.6666C19.0196 24.6651 19.3577 24.5236 19.6066 24.2733L24.2733 19.6066C24.5236 19.3577 24.6651 19.0196 24.6666 18.6666C24.6667 18.4906 24.632 18.3164 24.5645 18.1539C24.497 17.9915 24.398 17.844 24.2733 17.7199ZM18.6666 23.3333L12.6666 17.3333V12.6666H17.3333L23.3333 18.6666L18.6666 23.3333ZM14.3333 13.3333C14.531 13.3333 14.7244 13.3919 14.8888 13.5018C15.0533 13.6117 15.1814 13.7678 15.2571 13.9506C15.3328 14.1333 15.3526 14.3344 15.314 14.5283C15.2755 14.7223 15.1802 14.9005 15.0404 15.0404C14.9005 15.1802 14.7223 15.2755 14.5283 15.314C14.3344 15.3526 14.1333 15.3328 13.9506 15.2571C13.7678 15.1814 13.6117 15.0533 13.5018 14.8888C13.3919 14.7244 13.3333 14.531 13.3333 14.3333C13.3333 14.068 13.4386 13.8137 13.6261 13.6261C13.8137 13.4386 14.068 13.3333 14.3333 13.3333Z"/>
                    </svg>
                </button>
            </span>`;
            
        }
    }

    /**
     * Render hotspots content
     * 
     * @param {object} hotspot A hotspot object.
     * @param {integer} index A hotspot index.
     * @returns {undefined}
     */
    renderHotspotContent(hotspot, index) {
        let html = "";
        let positionY = hotspot.positionY;
        let positionX = hotspot.positionX + 6;

        if( positionY > 63 ) {
            positionY = positionY - 34;
        }

        if( positionX > 80) {
            positionX = positionX - 27;
        }

        if (this.hotspotJSON.image_hotspot.content_product) {

            html = `<div data-content="${index}" class="image-hotspot__content" style="top: ${positionY}%; left: ${positionX}%;">
                <product-hotspot data-product-handle="${hotspot.content}"><product-hotspot>
            </div>`;
        
        } else {

            html = `<div data-content="${index}" class="image-hotspot__content" style="top: ${positionY}%; left: ${positionX}%;">
            ${hotspot.content}
            </div>`;

        }

        return html;
    }

     /**
     * Init Events
     * 
     * @returns {undefined}
     */
    initEvents() {

        this.querySelectorAll("[data-hotspot]").forEach(hotspot => {

            hotspot.addEventListener('click', event => {
                event.preventDefault();

                this.toggleContent(hotspot);

            });

            // Close content on click out
            this.querySelector("img").addEventListener('click', () => {
                this.closeAllContents();
            });

            // Close content on window resize
            window.addEventListener('screen-breakpoint', () => {
                this.closeAllContents();
            });

            // Close content on press escape
            window.addEventListener('escape', () => {
                this.closeAllContents();
            });

        });
    }

    /**
     * Toggle hotspot content
     * 
     * @returns {undefined}
     */
     toggleContent(hotspot) {

        let hotspotContent = this.querySelector('[data-content="' + hotspot.dataset.hotspot + '"]');


        if (hotspotContent.classList.contains("visible")) {

            hotspotContent.classList.remove("visible");

        } else {

            this.closeAllContents();

            hotspotContent.classList.add("visible");

        }
    }

    /**
     * Close All hotspot contents
     * 
     * @returns {undefined}
     */
    closeAllContents() {

        this.querySelectorAll("[data-content]").forEach(content => {
            content.classList.remove("visible");
        });

    }
}

customElements.define(customElements.component, ImageHotspot);
}
